import React from "react";
import WanringIcon from "../../assets/images/icons/alert-circle-orange.svg";
import ErrorIcon from "../../assets/images/icons/alert-circle-red.svg";

export const Status = {
  Success: "success",
  Error: "error",
  Warning: "warning",
} as const;

export type StatusType = (typeof Status)[keyof typeof Status];

interface GeneralMessageProps {
  status: StatusType;
  className?: string;
  message: string;
}

const GeneralMessage: React.FC<GeneralMessageProps> = ({
  status,
  className = "",
  message,
}) => {
  const statusAttributes = {
    [Status.Error]: {
      className: "bg-error-00 border-error text-error",
      icon: ErrorIcon,
    },
    [Status.Success]: {
      className: "bg-green", 
      icon: ErrorIcon,
    },
    [Status.Warning]: {
      className: "bg-warning-50 text-orange border-orange",
      icon: WanringIcon,
    },
  };

  return (
    <div
      className={`flex items-center gap-2 rounded-lg border p-2 ${statusAttributes?.[status]?.className} ${className}`}
    >
      <img src={statusAttributes?.[status]?.icon} alt="message" />
      <p className="text-wrap">{message}</p>
    </div>
  );
};

export default GeneralMessage;
